import $ from 'jquery';

/**
 * Find a CDA narrative anchor inside the rendered iframe document.
 *
 * htmlname values look like "#Result.1.2.840.114350.1.13.535...Comp3". Epic
 * narratives put those on <tr ID="..."> (uppercase ID). jQuery's #id syntax
 * treats dots as class selectors, so #Result.1.2.840... never matches the row.
 */
export function findCdaNarrativeElement($contents, htmlname) {
  if (!$contents || !htmlname) {
    return $();
  }
  const anchorId = String(htmlname).replace(/^#/, '');
  if (!anchorId) {
    return $();
  }
  const quoted = anchorId.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  let el = $contents.find('[id="' + quoted + '"]');
  if (!el.length) {
    el = $contents.find('[ID="' + quoted + '"]');
  }
  if (!el.length && anchorId.indexOf('.') === -1) {
    el = $contents.find('#' + quoted);
  }
  return el;
}
